import React, { useMemo, createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertAvailableQuestions } from "./ExpertAvailableQuestionHook";

// Set the default state values for each context
export const ExpertAvailableQuestionsContext = /*#__PURE__*/createContext({});
export const ExpertAvailableQuestionsContextProvider = ({
  children
}) => {
  const availableContext = useExpertAvailableQuestions();
  const availableAllocationContext = useMemo(() => ({
    ...availableContext
  }), [availableContext]);
  return /*#__PURE__*/React.createElement(ExpertAvailableQuestionsContext.Provider, {
    value: availableAllocationContext
  }, children);
};
export const useExpertAvailableQuestionsContext = () => {
  return useContext(ExpertAvailableQuestionsContext);
};
ExpertAvailableQuestionsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};